import { createRoot } from 'react-dom/client';
import MagicBento from '../../components/MagicBento/MagicBento.jsx';

const GRID_SELECTOR = '.services__grid--magic';

document.querySelectorAll(GRID_SELECTOR).forEach((gridEl) => {
  const script = gridEl.querySelector('script.services-magic__payload[type="application/json"]');
  if (!script) {
    return;
  }

  let items;
  try {
    items = JSON.parse(script.textContent);
  } catch {
    return;
  }

  script.remove();

  if (!Array.isArray(items) || items.length === 0) {
    return;
  }

  const gridRef = { current: gridEl };
  const root = createRoot(gridEl);

  root.render(
    <MagicBento
      gridRef={gridRef}
      items={items}
      textAutoHide
      enableStars
      enableSpotlight
      enableBorderGlow
      enableTilt
      enableMagnetism
      clickEffect
      spotlightRadius={300}
      particleCount={12}
      glowColor="154, 233, 253"
    />,
  );
});
